export const wmoValue = "wmo";
export const wlzValue = "wlz";
export const jaValue = "ja";
export const neeValue = "nee";
export const jaLabel = "Ja";
export const neeLabel = "Nee";
export const formulierPageContainerClassName = "formulier-page-container formulier-page-container--opencak";
export const formulierPageContainerStepperFormClassName = "formulier-page-container-stepper-form";
